export const state = {
  // 打印进度条
  showProgress: false,
  progressData: {
    currentNum: 0,
    totalNum: 0,
    sucNum: 0,
    percentage: 0,
  },
  errorInfo: {
    errorTextList: false,
    errorData: [],
    filterTradeSids: [],
    filterItemSids: [],
    showErrorMessage: false,
    needOutSidColumn: false,
    needWaveIdColumn: false,
    extrNumber: 0,
  },
};
export const GET_SHOW_PROGRESS = 'get_show_progress';
export const GET_PROGRESS_DATA = 'get_progress_data';
export const UPDATE_PROGRESS_DATA = 'update_progress_data';
export const UPDATE_SHOW_PROGRESS = 'update_show_progress';
const mutations = {
  // 更新进度条数据
  UPDATE_PROGRESS_DATA(state, printNum) {
    const { progressData } = state;
    const { totalNum, currentNum } = progressData;
    let percentage = 0;
    if (currentNum !== 0) {
      percentage = parseInt(((currentNum + printNum) / totalNum) * 100);
    }
    state.progressData = Object.assign(progressData, {
      currentNum: (currentNum + printNum),
      percentage,
    });
  },
  UPDATE_ERROR_INFO(state, data) {
    const { errorInfo } = state;
    const { errorData = [], filterTradeSids = [], filterItemSids = [], extrNumber = 0 } = errorInfo;
    // 数据需要追加
    errorInfo['errorData'] = errorData.concat(data.errorData || []);
    errorInfo['filterTradeSids'] = filterTradeSids.concat(data.filterTradeSids || []);
    errorInfo['filterItemSids'] = filterItemSids.concat(data.filterItemSids || []);
    errorInfo['extrNumber'] = extrNumber + Number(data.extrNumber || 0);
    delete data['errorData'];
    delete data['filterTradeSids'];
    delete data['filterItemSids'];
    delete data['extrNumber'];
    state.errorInfo = Object.assign(errorInfo, {
      ...data,
    });
  },
  INIT_PRINT_DATA(state, progressData) {
    state.progressData = progressData;
  },
  // 显示进度条
  UPDATE_SHOW_PROGRESS(state, showProgress) {
    state.showProgress = showProgress;
  },
  INIT_ERROR_INFO(state) {
    state.errorInfo = {
      errorTextList: false,
      errorData: [],
      showErrorMessage: false,
      needOutSidColumn: false,
      needWaveIdColumn: false,
      extrNumber: 0,
    };
  },
};
const actions = {
  // 更新进度数据
  UPDATE_PROGRESS_DATA({ commit }, currentNum) {
    commit('UPDATE_PROGRESS_DATA', currentNum);
  },
  // 显示进度条
  UPDATE_SHOW_PROGRESS({ commit }, showProgress) {
    commit('UPDATE_SHOW_PROGRESS', showProgress);
  },
  INIT_PRINT_DATA({ commit }, data) {
    commit('INIT_PRINT_DATA', data);
  },
  UPDATE_ERROR_INFO({ commit }, data) {
    commit('UPDATE_ERROR_INFO', data);
  },
  // 异常数据
  INIT_ERROR_INFO({ commit }) {
    commit('INIT_ERROR_INFO');
  },
};
export const getters = {
  GET_SHOW_PROGRESS(state) {
    return state.showProgress;
  },
  GET_PROGRESS_DATA(state) {
    return state.progressData;
  },
  GET_PROGRESS_ERROR_INFO(state) {
    return state.errorInfo;
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
